import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Legacy route: Supabase password resets landed here from an emailed link.
 * Clerk resets are code-based and handled entirely on /forgot-password,
 * so this just forwards anyone with an old link.
 */
export function ResetPassword() {
  const navigate = useNavigate();

  useEffect(() => {
    navigate('/forgot-password', { replace: true });
  }, [navigate]);

  return null;
}

export default ResetPassword;
